var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 21.5H7.75C2.32 21.5 0 19.18 0 13.75V7.75C0 2.32 2.32 0 7.75 0H12.75C13.16 0 13.5 0.34 13.5 0.75C13.5 1.16 13.16 1.5 12.75 1.5H7.75C3.14 1.5 1.5 3.14 1.5 7.75V13.75C1.5 18.36 3.14 20 7.75 20H13.75C18.36 20 20 18.36 20 13.75V8.75C20 8.34 20.34 8 20.75 8C21.16 8 21.5 8.34 21.5 8.75V13.75C21.5 19.18 19.18 21.5 13.75 21.5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.75 9.5H16.75C13.33 9.5 12 8.17 12 4.75V0.75C12 0.45 12.18 0.17 12.46 0.0599999C12.74 -0.0600001 13.06 0.00999998 13.28 0.22L21.28 8.22C21.49 8.43 21.56 8.76 21.44 9.04C21.32 9.32 21.05 9.5 20.75 9.5ZM13.5 2.56V4.75C13.5 7.33 14.17 8 16.75 8H18.94L13.5 2.56Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 12.5H5.75C5.34 12.5 5 12.16 5 11.75C5 11.34 5.34 11 5.75 11H11.75C12.16 11 12.5 11.34 12.5 11.75C12.5 12.16 12.16 12.5 11.75 12.5Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 16.5H5.75C5.34 16.5 5 16.16 5 15.75C5 15.34 5.34 15 5.75 15H9.75C10.16 15 10.5 15.34 10.5 15.75C10.5 16.16 10.16 16.5 9.75 16.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.0ec10590e4d19d203047dc626f925070.svg";
export { ForwardRef as ReactComponent };